import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "../../csrfToken"

export default class ClaimStatusRefreshController extends Controller {
  static values = { url: String, needsRefresh: Boolean }

  declare urlValue: string
  declare needsRefreshValue: boolean

  connect(): void {
    if (!this.needsRefreshValue) return

    fetch(this.urlValue, {
      method: "POST",
      headers: csrfToken(),
    })
  }
}
